/* BaseNibApiMixin.js */

"use strict";
const JNIBError = require("./JnibError");
let mixin = (superKlass) =>
    class BaseNibApiMixin extends superKlass {
        /**
         * This method is called with the /<path>/<name>._jsnib reference to load it
         * in the Browsers JavaScript engine.
         * The ref is always a absolute reference starting with '/'.
         */
        pmLoadJSNIB(/*continuation, ref*/) {
            throw new JNIBError("pmLoadJSNIB() must be implemented!!!");
        }

        /**
         * This method is called with loadRef() call information to return
         * the completely resolved JSON.
         * The ref is always a absolute reference starting with '/'.
         */
        pmLoadRef(/*continuation, ref*/) {
            throw new JNIBError("pmLoadRef() must be implemented!!!");
        }

        /**
         * This method is called with loadRefUnresolved() call information to return
         * just the unresolved JSON object.
         * The ref is always a absolute reference starting with '/'.
         */
        pmLoadRefUnresolved(/*continuation, ref*/) {
            throw new JNIBError("pmLoadRefUnresolved() must be implemented!!!");
        }

        /**
         * This method is called with doesRefExist() call information to return
         * a true if the reference exists, otherwise false.
         * The ref is always a absolute reference starting with '/'.
         */
        pmDoesRefExist(/*continuation, ref*/) {
            throw new JNIBError("pmDoesRefExist() must be implemented!!!");
        }

        /**
         * This method is called with getExistingRefs() call information to return
         * a array of relative references from the passed reference.  An array is always returned.
         * It would be a empty array for a ref the doesn't have relative references or is not valid.
         * The ref is always a absolute reference starting with '/'.
         */
        pmGetExistingRefs(/*continuation, ref*/) {
            throw new JNIBError("pmGetExistingRefs() must be implemented!!!");
        }

        /**
         * This method is called with getRefContainer() call information to return
         * a object that has information about container the ref is from.
         * The ref is always a absolute reference starting with '/'.
         */
        pmGetRefContainer(/*continuation, ref*/) {
            throw new JNIBError("pmGetRefContainer() must be implemented!!!");
        }

        /**
         * This method is called with require() call information to return
         * a load javascript code in the browser.
         * The ref is always a absolute reference starting with '/'.
         */
        pmRequire(/*continuation, ref*/) {
            throw new JNIBError("pmRequire() must be implemented!!!");
        }

        /**
         * Storage Save Data
         */
        pmStorageSaveData(/*continuation, ref, data*/) {
            throw new JNIBError("pmStorageSaveData() must be implemented!!!");
        }

        /**
         * Internal method to update the errorObj with the errorIn and
         * ref information.
         */
        _updateRefErrorObj(ref, errorIn, errorObj) {
            if (errorIn.statusText) {
                errorObj.setMessage("ref: " + ref + ", error: " + errorIn.statusText);
            } else if (errorIn.errorMsg) {
                errorObj.setMessage("ref: " + ref + ", error: " + errorIn.errorMsg);
            } else {
                errorObj.setMessage("ref: " + ref + ", error: " + errorIn);
            }
        }
    };
module.exports = mixin;
